var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModeratorActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4165 5.53121C26.4165 6.53791 25.6003 7.35413 24.5936 7.35413C24.5823 7.35413 24.5728 7.34836 24.5615 7.34818L22.2592 20.0129C22.1326 20.7024 21.5311 21.2083 20.8247 21.2083H5.7583C5.05374 21.2083 4.44945 20.7043 4.32367 20.0111L2.02178 7.34957C2.01038 7.34957 2.00081 7.35413 1.9484 7.35413C0.941699 7.35413 0.125488 6.53791 0.125488 5.53121C0.125488 4.5245 0.982715 3.70829 1.9484 3.70829C2.91409 3.70829 3.77132 4.5245 3.77132 5.53121C3.77132 5.94127 3.61086 6.30094 3.38227 6.60536L7.46697 9.87294C8.19203 10.4531 9.2671 10.2167 9.68226 9.38622L12.3073 4.13622C11.7922 3.81493 11.4276 3.26806 11.4276 2.61454C11.4276 1.60784 12.2843 0.791626 13.2915 0.791626C14.2987 0.791626 15.0734 1.60784 15.0734 2.61454C15.0734 3.26806 14.7105 3.81493 14.1938 4.13668L16.8188 9.38668C17.2341 10.217 18.3095 10.4531 19.0341 9.8734L23.1188 6.60582C22.9302 6.30139 22.7707 5.90035 22.7707 5.53121C22.7707 4.52405 23.5864 3.70829 24.5936 3.70829C25.6007 3.70829 26.4165 4.52405 26.4165 5.53121Z",
    fill: "#0767FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeratorActive);
export default __webpack_public_path__ + "static/media/moderator-active.bdc8e213d5c5bd5c813dca417deeb966.svg";
export { ForwardRef as ReactComponent };